import { render } from "./PuzzleBonus.vue?vue&type=template&id=56a3df8c&scoped=true"
import script from "./PuzzleBonus.vue?vue&type=script&lang=js"
export * from "./PuzzleBonus.vue?vue&type=script&lang=js"

import "./PuzzleBonus.vue?vue&type=style&index=0&id=56a3df8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56a3df8c"

export default script